import { Grid, MenuItem, Select, Box } from '@mui/material';
import React from 'react';
import CAppFilterSelect from '../../../../../app/components/CAppFilterSelect';
import CAppSubTitle from '../../../../../app/components/CAppSubTitle';
import ITestData from '../interfaces/ITestData';

type CTestUiSelectsProps = {
	data: ITestData;
	setData: (params: ITestData) => void;
};
type TTestUiOptions = {
	id: number;
	name: string;
};
const CTestUiSelects = (props: CTestUiSelectsProps) => {
	const { data, setData } = props;

	const items = [
		{
			value: 1,
			label: 'Valeur n° 1',
		},
		{
			value: 2,
			label: 'Valeur n° 2',
		},
		{
			value: 3,
			label: 'Valeur n° 3',
		},
		{
			value: 4,
			label: 'Valeur n° 4',
		},
		{
			value: 5,
			label: 'Valeur n° 5',
		},
		{
			value: 6,
			label: 'Valeur n° 6',
		},
	];

	return (
		<>
			<Grid container spacing={3}>
				<Grid item sm={4}>
					<CAppSubTitle title="Select" subtitle="Outlined - Medium" />
					<Select
						label="Select - Outlined - Medium"
						variant="outlined"
						fullWidth
						size="medium"
						value={data && data.select ? data.select : ''}
						onChange={(e) =>
							setData({
								...data,
								select: e.target.value,
							})
						}
					>
						{items.map((item, index) => {
							return (
								<MenuItem key={index} value={item.value}>
									{item.label}
								</MenuItem>
							);
						})}
					</Select>
				</Grid>
				<Grid item sm={4}>
					<CAppSubTitle title="Select" subtitle="Filled - Medium" />
					<Select
						label="Select - Filled - Medium"
						variant="filled"
						fullWidth
						size="medium"
						value={data && data.select ? data.select : ''}
						onChange={(e) =>
							setData({
								...data,
								select: e.target.value,
							})
						}
					>
						{items.map((item, index) => {
							return (
								<MenuItem key={index} value={item.value}>
									{item.label}
								</MenuItem>
							);
						})}
					</Select>
				</Grid>
				<Grid item sm={4}>
					<CAppSubTitle title="Select" subtitle="Standard - Medium" />
					<Select
						label="Select - Standard - Medium"
						variant="standard"
						fullWidth
						size="medium"
						value={data && data.select ? data.select : ''}
						onChange={(e) =>
							setData({
								...data,
								select: e.target.value,
							})
						}
					>
						{items.map((item, index) => {
							return (
								<MenuItem key={index} value={item.value}>
									{item.label}
								</MenuItem>
							);
						})}
					</Select>
				</Grid>
				<Grid item sm={4}>
					<CAppSubTitle title="Select" subtitle="Outlined - Small" />
					<Select
						label="Select - Outlined - Small"
						variant="outlined"
						fullWidth
						size="small"
						value={data && data.select ? data.select : ''}
						onChange={(e) =>
							setData({
								...data,
								select: e.target.value,
							})
						}
					>
						{items.map((item, index) => {
							return (
								<MenuItem key={index} value={item.value}>
									{item.label}
								</MenuItem>
							);
						})}
					</Select>
				</Grid>
				<Grid item sm={4}>
					<CAppSubTitle title="Select" subtitle="Filled - Small" />
					<Select
						label="Select - Filled - Small"
						variant="filled"
						fullWidth
						size="small"
						value={data && data.select ? data.select : ''}
						onChange={(e) =>
							setData({
								...data,
								select: e.target.value,
							})
						}
					>
						{items.map((item, index) => {
							return (
								<MenuItem key={index} value={item.value}>
									{item.label}
								</MenuItem>
							);
						})}
					</Select>
				</Grid>
				<Grid item sm={4}>
					<CAppSubTitle title="Select" subtitle="Standard - Small" />
					<Select
						label="Select - Standard - Small"
						variant="standard"
						fullWidth
						size="small"
						value={data && data.select ? data.select : ''}
						onChange={(e) =>
							setData({
								...data,
								select: e.target.value,
							})
						}
					>
						{items.map((item, index) => {
							return (
								<MenuItem key={index} value={item.value}>
									{item.label}
								</MenuItem>
							);
						})}
					</Select>
				</Grid>
				<Grid item sm={4}>
					<CAppSubTitle title="CAppFilterSelect " subtitle="Autocomplete Multi Select" />
					<CAppFilterSelect
						multiple
						multipleRenderTags={(val: TTestUiOptions[]) => (
							<Box style={{ paddingLeft: '5px', fontSize: '0.85rem' }}>
								{/* {t(investmentFilterLang.x_funds.tag, { count: val ? val.length : 0 })} */}
								{val && val.map((x) => x.name).join(', ')}
							</Box>
						)}
						value={data && data.selects ? (data.selects as { id: string; name: string }[]) : null}
						onChange={(val: TTestUiOptions[]) => {
							setData({
								...data,
								selects: val,
							});
						}}
						label="Multi Autocomplete"
						size="small"
						options={
							items
								? items.map((x) => ({
										id: x.value,
										name: x.label,
								  }))
								: null
						}
					/>
				</Grid>
				<Grid item sm={4}>
					<CAppSubTitle title="CAppFilterSelect" subtitle="Autocomplete - Select Only" />
					<CAppFilterSelect
						value={data && data.select ? { id: data.select, name: data.select } : null}
						onChange={(val: TTestUiOptions) => {
							setData({
								...data,
								select: val ? val.id.toString() : null,
							});
						}}
						label="Select Autocomplete"
						size="small"
						options={
							items
								? items.map((x) => ({
										id: x.value,
										name: x.label,
								  }))
								: null
						}
					/>
				</Grid>
			</Grid>
		</>
	);
};

export default CTestUiSelects;
